import request from "../base/request";
import {applicationName} from "../utils";

let host = "/cm-sites-" + applicationName() + '/';

const Apis = {
    getStoryDetailResult: host + 'reportResult/getStoryDetailResult',//全部稿件统计
};

export const getStoryDetailResult = (body, callBack) => {  //全部稿件统计
    request({url:Apis.getStoryDetailResult, body, callBack});
};